module.exports = __webpack_public_path__ + "static/media/Team 14 Logo - Zhi Zhu.10a64ec9.jpeg";